import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { DataTable } from '../../table/Table';
import './TripHistoryModal.css';
import { mergeConsignment } from '../../../services/consignment/consignmentService';
import { toast } from 'react-toastify';
export const TripHistoryModal: React.FC<any> = ({
    setShowTripHistoryPopupHandler = (item: boolean) => {
        return item;
    },
    showModal,
    pagination,
}) => {
    const [tripShowModal, setTripShowModal] = useState(true);
    const [mergeId, setMergeId] = useState('');

    const columnDefinitions = {
        Consignment: [
            { label: 'ID', key: '_id' },
            { label: 'Consignment Group No', key: 'sConsignmentId' },
            { label: 'Vehicle Reg. No.', key: 'sRegNo' },
            { label: 'Location', key: 'sLocation' },
            { label: 'Temperature', key: 'sTemperature' },
            { label: 'Halt', key: 'sHalt' },
        ],
    };
    useEffect(() => {
        setTripShowModal(showModal);
        setShowTripHistoryPopupHandler(tripShowModal);
    }, [showModal]);
    const onClose = () => {
        setTripShowModal(false);
    };
    return (
        <Modal show={tripShowModal} onHide={onClose} contentClassName='modal-w-xxl'>
            <Modal.Header>
                <Modal.Title>Trip History</Modal.Title>
            </Modal.Header>
            <Modal.Body className='modal-body'>
                <div className='table-parent'>
                    <DataTable
                        columnDefinitions={columnDefinitions.Consignment}
                        paginatedItems={pagination}
                        isLoading={showModal}
                        tableFor='Consignment'
                        trackerColumn='sStatus'
                        hideActions={true}
                        mergeId={mergeId}
                    />
                    {pagination?.length ? '' : 'No Data'}
                </div>
            </Modal.Body>
        </Modal>
    );
};
